import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'

import TwoFaForm from 'features/auth/login/components/TwoFaForm/TwoFaForm'
import LoginCommonLayout from './components/LoginCommonLayout'
import LoginForm from './components/LoginForm/LoginForm'
import { StyledMainHeading } from './components/MainHeading/MainHeading'
import { loginMessages } from './messages'
import { StyledDescriptionText } from './styles'
import { LoginValues, LoginError } from './types'
import SignInFailed from './components/LoginForm/SignInFailed'

const initialLoginValues: LoginValues = {
  email: '',
  userId: '',
  password: '',
  clientId: '',
  twoFactor: { type: '' },
}

function LoginPage() {
  const { formatMessage } = useIntl()
  const [loginValues, setLoginValues] = useState(initialLoginValues)
  const [error, setError] = useState<LoginError | null>(null)

  useEffect(() => {
    if (error) {
      setLoginValues(initialLoginValues)
    }
  }, [error])

  if (error) {
    return <SignInFailed error={error} setError={setError} />
  }

  if (loginValues.password) {
    return <TwoFaForm loginValues={loginValues} setError={setError} />
  }

  return (
    <LoginCommonLayout>
      <StyledMainHeading>
        {formatMessage(loginMessages.loginHeading)}
      </StyledMainHeading>
      <StyledDescriptionText>
        {formatMessage(loginMessages.manageSavantHomes)}
      </StyledDescriptionText>
      <LoginForm setLoginValues={setLoginValues} setError={setError} />
    </LoginCommonLayout>
  )
}

export default LoginPage
